import * as React from 'react';
import type { UiView } from '../nav/model.ts';

// Simple ("Standard mode") vs Advanced: a per-browser presentation preference,
// not security. Stored under the old key so saved preferences carry over; a
// custom event fans changes out to every mounted consumer.
const KEY = 'cortex_ui_view';
const EVENT = 'cortex:ui-view';

export function getUiView(): UiView {
  try {
    return localStorage.getItem(KEY) === 'simple' ? 'simple' : 'advanced';
  } catch {
    return 'advanced';
  }
}

export function setUiView(view: UiView) {
  try {
    localStorage.setItem(KEY, view === 'simple' ? 'simple' : 'advanced');
  } catch {
    /* storage unavailable: the event still updates this tab */
  }
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function useUiView() {
  const [view, setView] = React.useState<UiView>(getUiView);
  React.useEffect(() => {
    const sync = () => setView(getUiView());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return { view, simple: view === 'simple', setUiView };
}
